import { render, staticRenderFns } from "./DataTableArea.vue?vue&type=template&id=2a9d238a"
import script from "./DataTableArea.vue?vue&type=script&lang=js"
export * from "./DataTableArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports